import React from 'react';
import { Modal, Box, Typography, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, makeStyles } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

const useStyles = makeStyles((theme) => ({
    modalBox: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 900,
        backgroundColor: '#fff',
        borderRadius: '16px',
        boxShadow: 24,
        padding: 0,
        outline: 'none',
        display: 'flex',
        flexDirection: 'column',
    },
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: theme.spacing(2, 3, 0, 3),
    },
    title: {
        flex: 1,
        textAlign: 'center',
        fontSize: 24,
        fontWeight: 700,
        marginBottom: 10
    },
    closeButton: {
        color: '#f44336',
        fontWeight: 'bold',
    },
    content: {
        display: 'flex',
        flexDirection: 'row',
        padding: theme.spacing(3),
        paddingTop: 0,
        minHeight: 400,
    },
    flowchart: {
        flex: 1.2,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRight: '1px solid #eee',
        minWidth: 320,
        minHeight: 350,
        paddingRight: theme.spacing(3),
    },
    triggerDetails: {
        flex: 2,
        paddingLeft: theme.spacing(3),
        display: 'flex',
        flexDirection: 'column',
    },
    sectionTitle: {
        fontWeight: 700,
        fontSize: 20,
        marginBottom: theme.spacing(2),
    },
    table: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        minWidth: 320,
    },
    statusTable: {
        marginTop: theme.spacing(2),
        minWidth: 320,
    },
    divider: {
        borderBottom: '1px solid #eee',
        margin: theme.spacing(2, 0),
    },
    label: {
        fontWeight: 600,
        marginRight: theme.spacing(1),
    },
}));

export default function ProcessFlowMappingDialog({ open, onClose, processFlow }) {
    const classes = useStyles();

    // Dummy data for the modal (replace with real data as needed)
    const flowName = processFlow?.processFlowName || 'Process Flow 1';
    const triggerType = 'Requirement Filter';
    const requirementCriteria = [
        { field: 'CoA', operator: '=', value: 'Present' },
        { field: 'Consumption Pages', operator: '=', value: 'Present' },
    ];
    const statusChange = [
        { fulfilled: 'YES', status: 'CMO QC Released', mapTo: 'NA' },
    ];

    return (
        <Modal open={open} onClose={onClose}>
            <form >
                <Paper elevation={0} className={classes.paper}>
                    <Box className={classes.modalBox}>
                        <div className={classes.header}>
                            <div style={{ flex: 1, display: 'flex', alignItems: 'center', position: 'relative' }}>
                                <Typography variant="h6" className={classes.title}>
                                    {flowName}
                                </Typography>
                                <IconButton onClick={onClose} className={classes.closeButton} size="small" style={{ position: 'absolute', right: 0, top: '50%', transform: 'translateY(-50%)' }}>
                                    <CloseIcon fontSize="large" />
                                </IconButton>
                            </div>
                        </div>
                        <div className={classes.content}>
                            {/* Left: Flowchart placeholder */}
                            <div className={classes.flowchart}>
                                {/* Replace with actual flowchart/diagram as needed */}
                                <img src="https://upload.wikimedia.org/wikipedia/commons/9/91/LampFlowchart.svg" alt="Flowchart" style={{ maxWidth: '100%', maxHeight: 340 }} />
                            </div>
                            {/* Right: Trigger Details */}
                            <div className={classes.triggerDetails}>
                                <Typography className={classes.sectionTitle}>Trigger Details</Typography>
                                <div className={classes.divider} />
                                <Typography style={{ fontWeight: 600, marginBottom: 8 }}>Select Trigger Type</Typography>
                                <Typography style={{ marginBottom: 16 }}>{triggerType}</Typography>
                                <Typography style={{ fontWeight: 600, marginBottom: 8 }}>Requirement Criteria</Typography>
                                <TableContainer component={Paper} className={classes.table}>
                                    <Table size="small">
                                        <TableHead>
                                            <TableRow style={{ background: '#F4F6F8' }}>
                                                {[
                                                    'Field',
                                                    'Opertor',
                                                    'Value'
                                                ].map((header) => (
                                                    <TableCell
                                                        key={header}
                                                        style={{
                                                            fontWeight: 700,
                                                            background: '#F4F6F8',
                                                            borderBottom: '2px solid #E0E0E0',
                                                            color: '#222',
                                                            fontSize: 12,
                                                            padding: '10px 10px',
                                                        }}
                                                    >
                                                        {header}
                                                    </TableCell>
                                                ))}
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {requirementCriteria.map((row, idx) => (
                                                <TableRow key={idx}>
                                                    <TableCell style={{ fontSize: 12, padding: '10px 10px' }}>{row.field}</TableCell>
                                                    <TableCell style={{ fontSize: 12, padding: '10px 10px' }}>{row.operator}</TableCell>
                                                    <TableCell style={{ fontSize: 12, padding: '10px 10px' }}>{row.value}</TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                                <Typography style={{ fontWeight: 600, marginTop: 16, marginBottom: 8 }}>Status Change</Typography>
                                <TableContainer component={Paper} className={classes.statusTable}>
                                    <Table size="small">
                                        <TableHead>
                                            <TableRow style={{ background: '#F4F6F8' }}>
                                                {[
                                                    'Requirement Criteria Fulfilled',
                                                    'Select Status',
                                                    'Map To Existing Status'
                                                ].map((header) => (
                                                    <TableCell
                                                        key={header}
                                                        style={{
                                                            fontWeight: 700,
                                                            background: '#F4F6F8',
                                                            borderBottom: '2px solid #E0E0E0',
                                                            color: '#222',
                                                            fontSize: 12,
                                                            padding: '10px 10px',
                                                        }}
                                                    >
                                                        {header}
                                                    </TableCell>
                                                ))}
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {statusChange.map((row, idx) => (
                                                <TableRow key={idx}>
                                                    <TableCell style={{ fontSize: 12, padding: '10px 10px' }}>{row.fulfilled}</TableCell>
                                                    <TableCell style={{ fontSize: 12, padding: '10px 10px' }}>{row.status}</TableCell>
                                                    <TableCell style={{ fontSize: 12, padding: '10px 10px' }}>{row.mapTo}</TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </div>
                        </div>
                    </Box>
                </Paper>
            </form>
        </Modal>
    );
} 